import axios from "axios";

const fetchWithToken = async (url, method = "GET", data = null) => {
  const token = sessionStorage.getItem("accessToken") || "your-fallback-token";
  if (!token) {
    throw new Error("Access token not found");
  }

  const config = {
    method,
    url,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  if (!(data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  if (data) {
    config.data = data;
  }

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    let errorMessage = "Error fetching data";
    if (error.response && error.response.data) {
      const data = error.response.data;
      // Prefer detailed errors if present
      if (data.errors && typeof data.errors === "object") {
        const fieldErrors = Object.entries(data.errors)
          .map(([field, messages]) => {
            const fieldName = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            const messageText = Array.isArray(messages) ? messages.join(', ') : messages;
            return `${fieldName}: ${messageText}`;
          })
          .join('\n');
        // If message exists, show both
        if (typeof data.message === "string" && data.message.trim() !== "") {
          errorMessage = `${data.message}\n${fieldErrors}`;
        } else {
          errorMessage = fieldErrors;
        }
      } else if (typeof data.message === "string") {
        errorMessage = data.message;
      } else if (typeof data.message === "object" && data.message !== null) {
        errorMessage = Object.entries(data.message)
          .map(([field, messages]) => {
            const fieldName = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            const messageText = Array.isArray(messages) ? messages.join(', ') : messages;
            return `${fieldName}: ${messageText}`;
          })
          .join('\n');
      } else if (data.error && typeof data.error === "object") {
        errorMessage = Object.entries(data.error)
          .map(([field, messages]) => {
            const fieldName = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            const messageText = Array.isArray(messages) ? messages.join(', ') : messages;
            return `${fieldName}: ${messageText}`;
          })
          .join('\n');
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export default fetchWithToken;